import React, { useState, useEffect } from 'react';

const WHATSAPP_NUMBER = '51940686868';
const WHATSAPP_MESSAGE = '¡Hola! Me gustaría saber más sobre sus formaciones y recursos 👋';

export default function WhatsAppWidget() {
  const [abierto, setAbierto] = useState(false);
  const [visible, setVisible] = useState(false);
  const [pulso, setPulso] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 2500);
    const t2 = setInterval(() => {
      setPulso(true);
      setTimeout(() => setPulso(false), 1000);
    }, 8000);
    return () => { clearTimeout(t1); clearInterval(t2); };
  }, []);

  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <>
      <style>{`
        .wa-widget {
          position: fixed;
          bottom: 28px;
          right: 28px;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 10px;
          font-family: 'DM Sans', sans-serif;
          opacity: 0;
          transform: translateY(16px);
          transition: opacity .4s ease, transform .4s ease;
          pointer-events: none;
        }
        .wa-widget.wa-widget--visible {
          opacity: 1;
          transform: translateY(0);
          pointer-events: all;
        }
        .wa-popup {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 8px 40px rgba(17,22,20,.14), 0 2px 8px rgba(17,22,20,.08);
          width: 290px;
          overflow: hidden;
          transform-origin: bottom right;
          transform: scale(.92) translateY(8px);
          opacity: 0;
          transition: transform .28s cubic-bezier(.34,1.56,.64,1), opacity .22s ease;
          pointer-events: none;
        }
        .wa-popup.wa-popup--open {
          transform: scale(1) translateY(0);
          opacity: 1;
          pointer-events: all;
        }
        .wa-popup__head {
          background: linear-gradient(135deg, #111614 0%, #1a2e26 100%);
          padding: 14px 16px 12px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .wa-popup__avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #25D366;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 0 0 3px rgba(130,216,179,.25);
        }
        .wa-popup__info { flex: 1; min-width: 0; }
        .wa-popup__nombre {
          font-size: .82rem;
          font-weight: 700;
          color: #82D8B3;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .wa-popup__estado {
          font-size: .68rem;
          color: rgba(130,216,179,.55);
          display: flex;
          align-items: center;
          gap: 4px;
          margin-top: 1px;
        }
        .wa-popup__dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #25D366;
          flex-shrink: 0;
          box-shadow: 0 0 5px #25D366;
        }
        .wa-popup__close {
          background: rgba(255,255,255,.08);
          border: none;
          border-radius: 50%;
          width: 26px;
          height: 26px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(255,255,255,.5);
          transition: background .2s, color .2s;
          flex-shrink: 0;
        }
        .wa-popup__close:hover {
          background: rgba(255,255,255,.15);
          color: #fff;
        }
        .wa-popup__body {
          padding: 14px 14px 6px;
          background: #f0f4f2;
          min-height: 70px;
        }
        .wa-bubble {
          background: #fff;
          border-radius: 12px 12px 12px 2px;
          padding: 10px 13px;
          font-size: .82rem;
          color: #111614;
          line-height: 1.45;
          box-shadow: 0 1px 3px rgba(0,0,0,.08);
          max-width: 230px;
          animation: waBubble .35s ease both;
        }
        @keyframes waBubble {
          from { opacity: 0; transform: translateY(6px) scale(.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
        .wa-bubble__time {
          font-size: .62rem;
          color: #a0b4ab;
          text-align: right;
          margin-top: 4px;
        }
        .wa-popup__footer {
          padding: 10px 14px 14px;
          background: #f0f4f2;
        }
        .wa-popup__btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: #25D366;
          color: #fff;
          font-family: 'DM Sans', sans-serif;
          font-weight: 700;
          font-size: .84rem;
          letter-spacing: .03em;
          border: none;
          border-radius: 100px;
          padding: .7rem 1.2rem;
          width: 100%;
          cursor: pointer;
          text-decoration: none;
          box-shadow: 0 4px 14px rgba(37,211,102,.32);
          transition: background .2s, transform .2s, box-shadow .2s;
          box-sizing: border-box;
        }
        .wa-popup__btn:hover {
          background: #1ebe5a;
          transform: translateY(-1px);
          box-shadow: 0 6px 20px rgba(37,211,102,.42);
        }
        .wa-popup__btn:active { transform: translateY(0); }
        .wa-fab {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          background: #25D366;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 24px rgba(37,211,102,.45), 0 2px 6px rgba(0,0,0,.12);
          transition: transform .22s cubic-bezier(.34,1.56,.64,1), box-shadow .22s;
          position: relative;
          flex-shrink: 0;
        }
        .wa-fab:hover {
          transform: scale(1.1);
          box-shadow: 0 8px 30px rgba(37,211,102,.55), 0 2px 8px rgba(0,0,0,.15);
        }
        .wa-fab:active { transform: scale(.96); }
        .wa-fab::before {
          content: '';
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          border: 2px solid #25D366;
          opacity: 0;
        }
        .wa-fab--pulso::before {
          animation: waPulso .9s ease-out;
        }
        @keyframes waPulso {
          0%   { opacity: .7; transform: scale(1); }
          100% { opacity: 0;  transform: scale(1.55); }
        }
        .wa-fab__badge {
          position: absolute;
          top: -2px;
          right: -2px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #ef4444;
          border: 2px solid #fff;
          font-size: .6rem;
          font-weight: 800;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: waFadeIn .4s ease both;
        }
        .wa-fab__badge--hidden { display: none; }
        @keyframes waFadeIn {
          from { opacity: 0; transform: scale(.5); }
          to   { opacity: 1; transform: scale(1); }
        }
        @media (max-width: 480px) {
          .wa-widget { bottom: 16px; right: 16px; }
          .wa-popup { width: 260px; }
        }
      `}</style>

      <div className={`wa-widget${visible ? ' wa-widget--visible' : ''}`}>

        <div className={`wa-popup${abierto ? ' wa-popup--open' : ''}`} role="dialog" aria-label="Chat de WhatsApp">

          <div className="wa-popup__head">
            <div className="wa-popup__avatar">
              <svg viewBox="0 0 24 24" fill="white" width="22" height="22">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <div className="wa-popup__info">
              <div className="wa-popup__nombre">Comunicar · Lenguaje</div>
              <div className="wa-popup__estado">
                <span className="wa-popup__dot" />
                En línea · Responde rápido
              </div>
            </div>
            <button className="wa-popup__close" onClick={() => setAbierto(false)} aria-label="Cerrar">
              <svg viewBox="0 0 20 20" fill="none" width="12" height="12">
                <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          <div className="wa-popup__body">
            {abierto && (
              <div className="wa-bubble">
                👋 ¡Hola! ¿En qué te podemos ayudar?<br/>
                Estamos disponibles para resolver tus dudas sobre formaciones y recursos.
                <div className="wa-bubble__time">ahora</div>
              </div>
            )}
          </div>

          <div className="wa-popup__footer">
            
             <a href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="wa-popup__btn"
              onClick={() => setAbierto(false)}
            >
              <svg viewBox="0 0 24 24" fill="white" width="17" height="17">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Iniciar conversación
            </a>
          </div>

        </div>

        <button
          className={`wa-fab${pulso ? ' wa-fab--pulso' : ''}`}
          onClick={() => setAbierto(v => !v)}
          aria-label="Abrir WhatsApp"
        >
          <span className={`wa-fab__badge${abierto ? ' wa-fab__badge--hidden' : ''}`}>1</span>

          {!abierto ? (
            <svg viewBox="0 0 24 24" fill="white" width="28" height="28">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
              <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          )}
        </button>

      </div>
    </>
  );
}